import {
	Button,
	Card,
	DynamicLink,
	Flex,
	Text,
} from "@capioweb/ui-components/src"
import React from "react"
import ContentLink from "../../@types/EpiFoundationSpa/Models/ContentLink"
import {
	ContentReferenceProperty,
	LinkListProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { LocalesContext } from "../../context"
import { assetBaseUrl } from "../../utils"
import { BlockCommonLayout } from "../../utils/layout"

interface PressAssetDownloadProps {
	heading: StringProperty
	imagePosition: StringProperty
	mediaFile: ContentReferenceProperty
	previewImage: StringProperty
	contentLink: ContentLink
	publishedDate: StringProperty
	alternateText: StringProperty
	fileName: StringProperty
}

interface CapioNexusMediaArchiveBlockProps {
	heading: StringProperty
	cta: LinkListProperty
	mediaPages: PressAssetDownloadProps[]
}

const AssetCard: React.FC<PressAssetDownloadProps> = (props) => {
	return (
		<Card
			w="100%"
			h={48.5}
			media={
				<>
					{props.mediaFile?.value?.url && (
						<img
							src={`${assetBaseUrl()}${
								props.mediaFile?.value?.url
							}?w=800&scale=down&format=webp`}
							alt={props.alternateText?.value}
							loading="lazy"
							style={
								props.imagePosition?.value === "center top"
									? { objectPosition: "center top" }
									: null
							}
						/>
					)}
				</>
			}
			borderColor="blue33"
		>
			<Card.DateLine>{props.publishedDate.value ?? ""}</Card.DateLine>
			<Card.TitleNews>
				{props.heading.value !== ""
					? props.heading.value
					: props.fileName.value}
			</Card.TitleNews>
		</Card>
	)
}

const CapioNexusMediaArchiveBlock: React.FC<CapioNexusMediaArchiveBlockProps> =
	({ mediaPages, heading, cta }) => {
		const { translate, translationKeys } = React.useContext(LocalesContext)
		const initalPageSize = 6
		const pageSize = 6
		const [visibleMediaPageCards, setVisibleMediaPageCards] = React.useState(
			mediaPages?.slice(0, initalPageSize) ?? []
		)

		const loadMore = () => {
			const currentIndex = visibleMediaPageCards.length

			setVisibleMediaPageCards([
				...visibleMediaPageCards,
				...mediaPages?.slice(currentIndex, currentIndex + pageSize),
			])
		}

		return (
			mediaPages?.length > 0 && (
				<BlockCommonLayout heading={heading}>
					<Flex justifyContent="center">
						<Text variant="paragraph-16" mb={4.5} mt={0.5}>
							{translate(translationKeys.assetsResultCount).replace(
								/%s/g,
								mediaPages.length.toString()
							)}
							:
						</Text>
					</Flex>
					<Flex
						w={1}
						flexWrap="wrap"
						justifyContent="flex-start"
						alignContent="space-between"
						columnGap={{ m: 3 }}
						rowGap={{ _: 2, m: 3 }}
						mb={{ _: 2, m: 3 }}
					>
						{visibleMediaPageCards.length > 0 &&
							visibleMediaPageCards.map((c, i) => {
								return (
									<Flex
										key={`mediaPage${i}`}
										w={1}
										flexShrink={1}
										flexGrow={0}
										flexBasis={{
											_: "100%",
											m: "calc(50% - 12px)",
											l: "calc(100% / 3 - 16px)",
										}}
										px={0}
									>
										{c?.contentLink?.url && (
											<DynamicLink url={c.contentLink.url ?? "#"}>
												<AssetCard {...c} />
											</DynamicLink>
										)}
									</Flex>
								)
							})}
					</Flex>

					<Flex w={1} justifyContent="center">
						<Button
							display={
								visibleMediaPageCards.length === mediaPages?.length
									? "none"
									: "inline-flex"
							}
							variant="ghost"
							textColor="navy"
							icon="plus"
							onClick={() => loadMore()}
							mt={{ _: 2, l: 5 }}
						>
							{translate(translationKeys.showMore) &&
								translate(translationKeys.showMore)}
						</Button>
					</Flex>
				</BlockCommonLayout>
			)
		)
	}

export { CapioNexusMediaArchiveBlock }
